import PlatformActions from './PlatformActions'

export default class JILITABLEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'JILI-TABLE-018',
      platform: 'JILI',
    }

    this.gameName = 'Super Bingo'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      betTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${txnId}`, // 383459259544764527
      roundId: `${roundId}`, // 218018720111695
      betType: null,
      currency,
      betTime, // 2021-10-01T13:11:15.798+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      settleTxnId,
      roundId,
      betAmount,
      winAmount,
      turnover,
      betTime,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${settleTxnId}`,
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2021-10-01T13:11:16.017+08:00
      roundId: `${roundId}`,
      betType: null,
      betTime, // 2021-10-01T13:11:15.798+08:00
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}`,
      roundId: `${roundId}`,
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
